import builder from '../builder';
import OfficeFileXls from '../../streamline-icons/light/office-file-xls.svg';

export default builder('IconOfficeFileXlsLight', OfficeFileXls);
